// ProfileHelpSection.jsx
import React from 'react';
import { Lock, MessageSquare } from 'lucide-react';

const ProfileHelpSection = () => {
  return (
    <div className="card">
      <div className="card-body">
        <h4>About Your Public Profile</h4>
        <p className="text-muted">
          Your public profile allows other screenwriters and industry professionals to discover your work.
          Only the scripts you choose to make public will be visible on your profile.
        </p>
        
        <div className="row mt-4">
          <div className="col-md-6 mb-3">
            <div className="card h-100">
              <div className="card-body">
                <h5 className="d-flex align-items-center">
                  <Lock size={16} className="me-2 text-primary" /> Privacy Controls
                </h5>
                <p className="card-text text-muted small">
                  You can make your profile private at any time, and control exactly which scripts are visible
                  and how much information is shared for each one.
                </p>
              </div>
            </div>
          </div>
          
          <div className="col-md-6 mb-3">
            <div className="card h-100">
              <div className="card-body">
                <h5 className="d-flex align-items-center">
                  <MessageSquare size={16} className="me-2 text-primary" /> Networking
                </h5>
                <p className="card-text text-muted small">
                  Allow other users to message you and request connections to build your network
                  of collaborators and industry contacts.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileHelpSection;